var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55334 0.781088C7.86095 -0.122599 9.13905 -0.122601 9.44666 0.781085L10.7389 4.57756C10.8769 4.98282 11.2575 5.25532 11.6856 5.25532H15.7649C16.7449 5.25532 17.1401 6.51859 16.3348 7.07705L13.1158 9.30948C12.7489 9.56393 12.5952 10.0308 12.7391 10.4534L13.9873 14.1205C14.2981 15.0336 13.2634 15.8141 12.4707 15.2644L9.06988 12.9059C8.72714 12.6682 8.27286 12.6682 7.93012 12.9059L4.52926 15.2644C3.73659 15.8142 2.70188 15.0336 3.01272 14.1205L4.26095 10.4534C4.40482 10.0308 4.25106 9.56393 3.88417 9.30948L0.665168 7.07705C-0.140084 6.51859 0.255101 5.25532 1.23505 5.25532H5.31439C5.74249 5.25532 6.1231 4.98282 6.26105 4.57756L7.55334 0.781088Z",
    fill: "#DDE3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.8b743f5e2cddea4740a064a4ae858a99.svg";
export { ForwardRef as ReactComponent };